import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
export function Hero() {
  const headline = 'RuslanSilvr';
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-33">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-34">
        <motion.video initial={{
        scale: 1.1,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 0.85
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/gBboVSJ6CTXUjcNWiurCNr/optimized_website_background.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover object-center" data-id="element-35" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-brand-black/30 to-transparent" data-id="element-36" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-black via-transparent to-brand-black/60" data-id="element-37" />
      </div>

      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-6 md:px-12 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-38">
        <motion.img src="https://cdn.magicpatterns.com/uploads/1RtWnisnhQF46LZNf8vGfn/RuslanSilvr-6.png" alt="RuslanSilvr" initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full max-w-[90vw] md:max-w-[80vw] h-auto mb-6 select-none" data-id="element-39" />

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 1
      }} className="text-lg md:text-2xl text-brand-muted max-w-xl mb-10 font-light" data-id="element-40"></motion.p>

        <motion.form initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.4,
        duration: 0.8
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto max-w-lg" onSubmit={e => e.preventDefault()} data-id="element-41">
          <input type="email" placeholder="ENTER YOUR EMAIL" required className="flex-1 bg-brand-black/40 border border-brand-white/30 px-6 py-4 text-brand-white placeholder:text-brand-white/50 focus:outline-none focus:border-brand-white focus:bg-brand-black/60 transition-all font-medium tracking-widest backdrop-blur-sm" data-id="element-42" />
          <button type="submit" className="bg-brand-white text-brand-black px-8 py-4 font-display tracking-widest uppercase hover:bg-brand-accent hover:text-brand-white transition-colors" data-id="element-43">
            Subscribe
          </button>
        </motion.form>
      </div>
    </section>;
}